import { post, get, del, put } from './requests'

export const getReconcileItems = key => {
  const timeZoneId = Intl.DateTimeFormat().resolvedOptions().timeZone
  return post(
    ['api', `reconcile`],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    { timeZoneId }
  )
}

export const checkReconcileItem = key => payload =>
  post(
    ['api', 'reconcile', 'check'],
    {
      removeTrailingSlash: true,
      headers: { Authorization: `Bearer ${key}` },
    },
    payload
  )



// WEBPACK FOOTER //
// ./src/services/reconcile.js